/**
 * WEB-916 п.2 — ссылки условий на публичной странице красились акцентом
 * (`--color-primary`, фолбэк #1677ff). QA намерил 3.68–3.93:1 — для текста
 * мало, порог WCAG 1.4.3 = 4.5:1. Разброс объясняется тем, что фактическое
 * значение задаёт палитра стиль-пака, поэтому один литерал тут не поможет.
 *
 * Решение: отдельный токен ссылки. Тема эмитит его как акцент, притемнённый
 * до порога относительно поверхности (themes/index.ts, darkenToContrast), а
 * дефолт держит порог для нетемизированных поверхностей.
 */

/** Порог WCAG 1.4.3 для обычного (не крупного) текста. */
export const LINK_MIN_CONTRAST = 4.5;

/**
 * WEB-916 п.2, возврат приёмки: цель ПОДБОРА цвета, чуть выше порога ПРОВЕРКИ.
 *
 * Прошлый заход подбирал ровно до 4.5 и садился на границу — живой замер QA
 * дал 4.21, потому что реальная поверхность (фон страницы) отличалась от той,
 * против которой считали (surface). Набор поверхностей теперь честный
 * (darkenToContrastAll), но садиться ровно на границу всё равно не стоит:
 * округление замерялки и сглаживание шрифта съедают сотые. Запас на один шаг
 * притемнения глазу незаметен, а замер уводит с границы.
 *
 * Гейт (тесты) проверяет LINK_MIN_CONTRAST — норму, а не наш запас.
 */
export const LINK_CONTRAST_TARGET = 4.6;

/** Значение токена в светлой теме (см. styles/global.css). */
export const LINK_DEFAULT = '#0958d9';

/** Цвет ссылки на поверхности — читать только отсюда. */
export const LINK_ON_SURFACE_COLOR = `var(--color-link, ${LINK_DEFAULT})`;
